import React from "react";
import "../theme/app-styles.css";
import "./info-styles.css";

import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/react";

import Footer from "../components/Footer";


const sponsorForm = "https://www.dropbox.com/scl/fi/wiz013o06kc91s718k79t/sponsor-attestation-new.pdf?rlkey=w61cdrjfxmop15lbwpg5kjzw3&st=87a9a4tz&dl=0";
const Sponsors: React.FC = () => {
  return (
    <IonPage className="info-page">
      <IonHeader>
        <IonToolbar color="primary" className="info-page-header">
          <IonTitle className="ion-text-center">OCIA Sponsors</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="background-image">
        <div className="content-container">
          <h1 className="text-title" id="about">
            OCIA Sponsor: Helping Prospective New Catholics through their
            Formation
          </h1>
          <p className="quote-text">“Modern men and women listen more willingly to witnesses than to teachers…”</p>
          <p className="body-text">
            The above quote from Pope St. Paul VI’s encyclical on
            evangelization, perfectly captures the vital role played by the OCIA
            sponsor in the spiritual formation of our candidates currently
            working through the OCIA process towards sacramental initiation, 
            full reception, or completion of their Sacraments (Confirmation and/or First Holy Communion) in the Holy Catholic Church.</p>
            <p className="body-text"> In the OCIA sessions,
            these souls learn <strong>the what and the why</strong> regarding the many aspects of
            the Faith; the Sacraments, how to read the bible, the story of
            creation, the fall, and salvation, various prayers and how to pray,
            the precepts, moral laws, and virtues, and most importantly the
            importance of a personal relationship with Jesus Christ.</p>
            <p className="body-text"> But the
            vital role of the OCIA Sponsor is <strong>teaching the how!</strong> How does the
            ordinary Catholic layperson live out his or her relationship with Jesus
            Christ and the Church on a practical, day-to-day basis?</p>
            <p className="body-text">The
            sponsor does this by accompanying a candidate through the process;
            meeting with him or her regularly, talking about the journey,
            listening to the challenges, and sharing with the candidate aspects
            of the sponsor’s own faith journey and personal story. And as this
            relationship grows, the sponsor affirms the candidate progress,
            presenting him or her to the priest, or Bishop, and to the gathered
            assembly at the various OCIA rites celebrated during Lent and
            Easter.
          </p>
          <p className="body-text" style={{ fontStyle: "italic", fontWeight: "600"}}>The minimum requirements for an OCIA sponsor are:</p>
          <ul className="bullet-list">
            <li className="bullet-text">
              Must be 16 years or older. (But preferably someone with lived
              experience as a Catholic adult for five or more years.)
            </li>
            <li className="bullet-text">
              Must be a Catholic in good standing (e.g., attends Mass
              regularly).
            </li>
            <li className="bullet-text">
              Must have received their own Sacraments of Baptism, Holy Communion
              and Confirmation.
            </li>
            <li className="bullet-text">
              Either unmarried, or if married, his/her marriage must have been
              performed in a Catholic Church (or marriage been “blessed” (called
              “convalidation”) by the Church).
            </li>
            </ul>
            <div>

            <p><strong>It is strongly recommended that the sponsor be able to attend most of the liturgical celebrations that
              mark the Candidate&apos;s spiritual progress through the program!</strong>
            </p>
            <p>
              <strong>Must download and complete the <a href={sponsorForm}>Sponsor Attestation Form</a> and 
              return it, as directed at the bottom of the form, by October 31st.</strong>
            </p>
            </div>
      
        <div className="links-container">
          <p className="link-description">Get Sponsor Attestation Form  <a href={sponsorForm}>here</a></p>
          </div>
        
          
<Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Sponsors;
